export default __webpack_public_path__ + "static/media/Header-10.79a7dbb1.jpg";